import { ErrorHandler, NgModule } from '@angular/core'
import { MatFormFieldDefaultOptions, MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field'
import { BrowserModule } from '@angular/platform-browser'
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'
import { RouterModule } from '@angular/router'
import { Store } from '@ngrx/store'
import * as Sentry from '@sentry/angular'
import { environment } from '../environments/environment'
import { AppComponent } from './app.component'
import { AppsModule } from './core/apps/apps.module'
import { autologin } from './core/auth/auth.actions'
import { AuthModule } from './core/auth/auth.module'
import { AnonymousUserGuard } from './core/guards/anonymous-user.guard'
import { AuthorizedUserGuard } from './core/guards/authorized-user.guard'
import { AppStoreModule } from './core/store/store.module'
import { AppLayoutGuard } from './pages/app-layout/app-layout.guard'

if (environment.sentry) {
  Sentry.init({
    dsn: environment.sentry.dsn,
    environment: environment.sentry.env,
    release: environment.version.hash,
    integrations: [
      // new Integrations.BrowserTracing({
      //   tracingOrigins: [environment.apiUrl, environment.auctioneerApiUrl],
      //   routingInstrumentation: Sentry.routingInstrumentation,
      // }),
    ],

    // We recommend adjusting this value in production, or using tracesSampler
    // for finer control
    tracesSampleRate: 1.0,
  })
}

const SentryProviders = environment.sentry
  ? [
      {
        provide: ErrorHandler,
        useValue: Sentry.createErrorHandler({
          logErrors: true,
        }),
      },
      // {
      //   provide: Sentry.TraceService,
      //   deps: [Router],
      // },
      // {
      //   provide: APP_INITIALIZER,
      //   useFactory: () => () => {},
      //   deps: [Sentry.TraceService],
      //   multi: true,
      // },
    ]
  : []

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppStoreModule,
    AuthModule,
    AppsModule,
    RouterModule.forRoot(
      [
        {
          path: 'auth',
          canActivate: [AnonymousUserGuard],
          loadChildren: () => import('./pages/auth-layout/auth-layout.module').then((m) => m.AuthLayoutModule),
        },
        {
          path: 'app/:appId',
          canActivate: [AppLayoutGuard],
          loadChildren: () => import('./pages/app-layout/app-layout.module').then((m) => m.AppLayoutModule),
        },
        {
          path: '',
          canActivate: [AuthorizedUserGuard],
          loadChildren: () => import('./pages/private-layout/private-layout.module').then((m) => m.PrivateLayoutModule),
        },
      ],
      {
        initialNavigation: 'enabledBlocking',
        onSameUrlNavigation: 'reload',
        paramsInheritanceStrategy: 'always',
      }
    ),
  ],
  providers: [
    ...SentryProviders,
    {
      provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
      useValue: <MatFormFieldDefaultOptions>{
        appearance: 'outline',
      },
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {
  constructor(store: Store) {
    store.dispatch(autologin())
  }
}
